<div class="tell-your-friends" [ngClass]="{ compacted: compacted }">
  <fa-icon *ngIf="compacted" class="share-icon" [icon]="shareIcon"></fa-icon>
  <span class="share-text" i18n="@@share.title">Share</span>
  <ul class="social-links">
    <li *ngFor="let sl of socialLinks">
      <a [href]="onShareLink(sl)" (click)="onShareLinkClicked(sl)" target="_blank">
        <fa-icon [icon]="sl.iconProp"></fa-icon>
      </a>
    </li>
  </ul>
</div>
